<template>
  <div v-frag>
    <CardIeaAppMain colorCard="#A7BA38" title="">
      <!-- <v-row> -->
      <v-col cols="12" sm="12" xs="12" md="12" lg="12" xl="12">
        <v-btn
          class="mx-2"
          fab
          dark
          small
          color="success"
          @click="$router.push({ name: 'Home' })"
        >
          <v-icon dark>
            mdi-keyboard-backspace
          </v-icon>
        </v-btn>
        <br/><br/>
        <div class="text-xs-h4 text-sm-h4 text-md-h4 text-lg-h4 text-xl-h4 primary-text">{{ title }}</div>
        <br/>
        <v-row no-gutters>
          <v-col cols="12" xs="12" sm="12" md="12" xl="12" lg="12">
            <v-alert
              prominent
              type="info"
            >
              Lea con atención: Esta sección solo se aceptan denuncias respecto al trabajo, trato del personal de la institución. Las denuncias deben ser personales, es decir a una única persona. Y clarificar los hechos sucedidos. Si no cumple, la denuncia será desentendida. Toda denuncia de otra índole y consulta debe ser canalizada por el lugar correspondiente, en <a style="color: white;" href="tramite"> Consultas</a>
            </v-alert>
          </v-col>
        </v-row>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-text-field
              v-model="titulo"
              label="Describa en pocas palabras su denuncia"
              required
            > 
            </v-text-field>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-select
              v-model="prioridad"
              :items="prioridades"
              item-text="text"
              item-value="value"
              label="Selecciona la prioridad"
              persistent-hint
              return-object
              single-line
            >
            </v-select>
          </v-col>
          <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
            <v-textarea
              name="input-7-1"
              v-model="texto"
              label="Describa en detalle la denuncia"
            >
            </v-textarea>
          </v-col>
        </v-row>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
          <v-select
            v-model="tipo"
            :items="types"
            item-text="text"
            item-value="value"
            label="Denunciar a:"
            persistent-hint
            return-object
            single-line
            v-on:change="getUsers"
          ></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-if="tipo.value !== '3'">
              <v-select
                  v-model="persons"
                  :items="allpersons"
                  item-text="nombre"
                  item-value="id"
                  attach
                  chips
                  label="Selecciona la o las personas a denunciar"
                  multiple
                ></v-select>
        </v-col>
        <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" v-else>
          <v-text-field
            v-model="otroCampo"
            label="Escriba a quien quiere denunciar"
            required
          ></v-text-field>
        </v-col>
        <v-row align="center">
          <v-col cols="12" xs="12" sm="12" md="2" lg="6" xl="6">
            <v-btn
              color="success"
              elevation="7"
              large
              v-on:click="examen = true"
              @click="addDenuncia()"
              >Crear denuncia</v-btn
            >
          </v-col>
        </v-row>
        <div>
          <br/>
          <h2>
            Mis denuncias
          </h2>
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">
                    Título
                  </th>
                  <th class="text-left">
                    Estado
                  </th>
                  <th class="text-left">
                    Respuesta
                  </th>
                  <th class="text-left">
                    Fecha
                  </th>
                  <th class="text-left">
                    Opción
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(denunciaUserData,
                  denunciaUserKey) in denunciasUser"
                  :key="denunciaUserKey"
                > 
                  <td>{{ denunciaUserData.titulo }}</td>
                  <td>
                    <strong v-if="denunciaUserData.estado == '0'">
                      Sin atender
                    </strong>
                    <strong v-else-if="denunciaUserData.estado == '1'" style="color:#D8A505">
                      Esperando resolución
                    </strong>
                    <strong v-else-if="denunciaUserData.estado == '2'" style="color:green">
                      Resuelto
                    </strong>
                    <strong v-else-if="denunciaUserData.estado == '3'" style="color:red">
                      Desentendido
                    </strong>
                  </td>
                  <td v-if="denunciaUserData.respuesta">
                    <v-dialog
                      v-model="dialog"
                      width="500"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          color="blue lighten-2"
                          dark
                          v-bind="attrs"
                          v-on="on"
                        >
                          Ver respuesta
                        </v-btn>
                      </template>

                      <v-card>
                        <v-card-title class="headline grey lighten-2">
                          Respuesta
                        </v-card-title>

                        <v-card-text>
                        {{ denunciaUserData.respuesta }}
                        </v-card-text>
                      </v-card>
                    </v-dialog>
                    
                  </td>
                  <td v-else>Sin respuesta</td>
                  <td>{{ denunciaUserData.tiempo }}</td>
                  <td>
                    <v-btn
                      color="error"
                      elevation="7"
                      v-on:click="examen = true"
                      @click="deleteDenuncia(denunciaUserData.id)"
                      >Dar de baja</v-btn
                    >
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
      </v-col>
      <!-- </v-row> -->
    </CardIeaAppMain>
  </div>
</template>

<script>
// import CardIeaApp from "../../components/CardIeaApp";
import CardIeaAppMain from "../../components/CardIeaAppMain";

export default {
  name: "Denuncia",
  components: {
    // CardIeaApp,
    CardIeaAppMain,
  },

  data: () => ({
    title:"Nueva denuncia",
    titulo: '',
    texto: '',
    sede: {text:'', value:''},
    prioridad: {text:'', value:''},
    select: {},
    otroCampo:'',
    prioridades: [
      { text: 'Baja', value: '0' },
      { text: 'Media', value: '1' },
      { text: 'Alta', value: '2' },
      { text: 'Emergencia', value: '3' },
    ],
    types: [
      { text: 'Profesor', value: '1' },
      { text: 'Administrativo/Cobrador', value: '2' },
      { text: 'Otros', value: '3' },
    ],
    tipo: '',
    persons: [],
    allpersons: [],
    denunciasUser:[],
    sedes:[],
    person: '',
    personRules: [
        v => !!v || 'Campo obligatorio',
      ],
  }),
  
  methods: {
    async addDenuncia() {
      // base de datos aceptado feedback
      let titulo =  this.titulo;
      let texto =  this.texto;
      let nivel =  this.prioridad.value ;
      let otroCampo =  this.otroCampo;
      let dataSend = {
        titulo: titulo,
        texto: texto,
        nivel: nivel,
      };

      if(titulo.trim() == '' || texto.trim() == '' || nivel == ''){
        alert('Por favor llena todos los campos');
        return;
      }
      if(this.tipo.value == 3){
        if(otroCampo == ''){
          alert('Escriba el nombre de la persona que denuncias');
          return;
        }else{
          dataSend.otroCampo = otroCampo;
          dataSend.otroCheck = 1;
        }
      }else{
        if(this.persons.length == 0){
          alert('Selecciona por lo menos una a persona a denunciar');
          return;
        }else{
          dataSend.usuarios = this.persons;
        }
      }
      
      console.log(dataSend);
      
      let url = "reclamos/store";
      await this.$API
        .post({
          url: url,
          data: dataSend
        }).then(() => {
          this.loadDenuncias();
        }); 
    },

    async deleteDenuncia(id) {
      if(confirm('¿Desea dar de baja a denuncia?')){

        let url = "reclamos/baja/" + id;
       
        await this.$API
          .post({
            url: url,
          }).then(() => {
            this.loadDenuncias();
            
          });
      }else{
        return;
      }      
    },

    async loadDenuncias() {

      let url = "reclamos/index";
     
      await this.$API
        .get({
          url: url
        }).then((res) => {
          this.denunciasUser = res;
          
        });
    },

    async getUsers(sel) {
      if(sel.value  !== 3){
        let url = "reclamos/tipo-usuario/" + sel.value;
        await this.$API
          .get({
            url: url
          }).then((res) => {
            this.allpersons = res;
            
          });
      }
    }
  },

  mounted() {
    if(this.$store.getters.user.borrado == 1 ||  this.$store.getters.user.alumno_mora ==  true){
      this.$router.push({
          name: "Home"
        });
    }
    this.$API
    .get({
      url: "reclamos/index"
    }).then((res) => {
      this.denunciasUser = res;
      
    });
  },
};
</script>
